<button [attr.size]="size" [attr.color]="color"  [attr.kind]="kind">
   <ng-content></ng-content>
</button>